import React from 'react'

import WorkSummaryCardContainer from '../../containers/work-summaries/work-summary-card-container'
import { Collection, Group } from '../details/collection'

import {
  CollectionButton
} from '../buttons'

export default ({
  inProgress,
  pendingApproval,
  archive,
  pathname,

  hasNextPage,
  onLoadNextPage,
  onLoadFirstPage
}) => (
  <div className='work-summary'>
    <div className="form-group list-search collection-search">
      <input type="search" onChange={(event) => {
        onLoadFirstPage(event.target.value)
        return event;
      }} placeholder='Filter by Location...' className='form-control form-control-lg'/>
    </div>
    <Collection>
      {inProgress && <Group title='In progress'>
        {workSummaryList(inProgress, pathname)}
      </Group>}
      {pendingApproval && <Group title='Pending approval'>
        {workSummaryList(pendingApproval, pathname)}
      </Group>}
      {archive && <Group title='Archive'>
        {workSummaryList(archive, pathname)}
      </Group>}
    </Collection>

    {hasNextPage &&
      <CollectionButton onClick={() => {onLoadNextPage('marriott')}}>See more...</CollectionButton>}
  </div>
)

function workSummaryList (collection, pathname) {
  return collection.map(workSummary =>
    <WorkSummaryCardContainer key={workSummary.id} pathname={pathname} workSummaryId={workSummary.id} />)
}



// WEBPACK FOOTER //
// ./src/components/work-summaries/work-summaries.js